<template>
  <box-generic w-stretch :header="label" :header-class="computedHeaderClass">
    <div class="grow">
      <form class="relative">
        <input
          type="text"
          ref="query"
          :value="modelValue"
          @keydown.esc="$emit('update:modelValue', '')"
          @keydown.enter.prevent=""
          @input="$emit('update:modelValue', $event.target.value)"
          class="w-full focus:outline-none border border-solid border-t-white border-r-white box-border font-light p-[7px] pr-[36px]"
          :class="computedInputClass"
        />
        <transition-fade :duration="200">
          <input
            v-if="modelValue.length"
            type="button"
            value="×"
            @click.prevent="$emit('update:modelValue', '')"
            class="absolute right-0 py-1 px-3 text-2xl bg-transparent cursor-pointer opacity-75 hover:opacity-100 transition-opacity duration-200"
          />
          <svg
            v-else
            width="20"
            height="21"
            fill="none"
            viewBox="0 0 20 21"
            xmlns="http://www.w3.org/2000/svg"
            class="absolute right-0 inset-y-0 w-8 h-full py-2 text-almostBlack text-opacity-25 stroke-current stroke-2 pointer-events-none"
          >
            <circle cx="7" cy="7" r="6" />
            <line x1="11.4512" y1="11.537" x2="19.2294" y2="19.3152" />
          </svg>
        </transition-fade>
      </form>
    </div>
  </box-generic>
</template>

<script>
import BoxGeneric from "../BoxGeneric.vue";
import TransitionFade from "../../magic/TransitionFade.vue";

import { mapGetters } from "vuex";

export default {
  name: "MediaArchiveSearchBox",
  components: {
    TransitionFade,
    BoxGeneric,
  },
  computed: {
    ...mapGetters(["routedSong"]),
    ...mapGetters(["activeSeasonContentForSchoolLevel"]),

    /**
     * Computes the header class for the BoxGeneric component.
     * Always includes the base "title-block" class.
     * If a school level is active, adds a modifier class based on its slug,
     * e.g., "title-block-onderbouw", "title-block-middenbouw", etc.
     */
    computedHeaderClass() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      return slug ? `title-block title-block-${slug}` : "title-block";
    },
    computedInputClass() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      if (!slug) return "";

      const bgMap = {
        onderbouw: "border-b-green border-l-green",
        "midden-bovenbouw": "border-b-purple border-l-purple",
      };

      return bgMap[slug] || "";
    },
  },
  props: {
    label: {
      type: String,
    },
    modelValue: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  mounted() {
    this.$refs.query.focus();
  },
};
</script>
